import React, { PropsWithChildren, ReactElement } from "react";
import styles from "./packageDescription.module.scss";

export const PackageDescription = (props: PropsWithChildren): ReactElement => {
  return <div className={styles.description}>{props.children}</div>;
};
